import React, { useEffect, useState } from "react";
import Account from "../../../Services/accountServices";
import ExportComponents from "../../../Components/ExportComponents";
import USDFigure from "../../../Components/USDFigure";
import AFNFigure from "../../../Components/AFNFigure";
import TitleHeader from "../Components/TitleHeader";
function TrialBalance(props) {
  const [trialBalances, setTrialBalances] = useState([]);
  const [downloadingData, setDownloadingData] = useState([]);
  const fetchTrialBalace = () => {
    Account.getTrialBalance().then((line) => {
      setTrialBalances(line.data);

      const excelData = line.data.map((item) => ({
        account: item.accountName,
        debit: item.debit,
        credit: item.credit,
      }));
      setDownloadingData(excelData);
    });
  };
  useEffect(() => {
    fetchTrialBalace();
  }, []);
  return (
    <div class="page-wrapper">
      <div class="content container-fluid">
        <TitleHeader title="Trial Balance" />

        <div class="row">
          <div class="col-sm-12">
            <div class="card">
              <div class="card-body">
                <ExportComponents
                  excelData={downloadingData}
                  fileName="TrialBalance.xlsx"
                />
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Account Name</th>
                        <th>Debit</th>
                        <th>Credit</th>
                      </tr>
                    </thead>
                    <tbody>
                      {trialBalances.map((item) => {
                        return (
                          <tr>
                            <td>{item.accountName}</td>
                            <td>
                              {item.accountName.includes("AFN") ? (
                                <AFNFigure amount={item.debit} />
                              ) : (
                                <USDFigure amount={item.debit} />
                              )}
                            </td>
                            <td>
                              {item.accountName.includes("AFN") ? (
                                <AFNFigure amount={item.credit} />
                              ) : (
                                <USDFigure amount={item.credit} />
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td>
                          <strong>Total USD</strong>
                        </td>
                        <td>
                          <strong>
                            <USDFigure
                              amount={trialBalances.reduce(
                                (accumulator, currentObject) => {
                                  if (
                                    !currentObject.accountName.includes("AFN")
                                  )
                                    return accumulator + currentObject.debit;
                                  return accumulator;
                                },
                                0
                              )}
                            />
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <USDFigure
                              amount={trialBalances.reduce(
                                (accumulator, currentObject) => {
                                  if (
                                    !currentObject.accountName.includes("AFN")
                                  )
                                    return accumulator + currentObject.credit;
                                  return accumulator;
                                },
                                0
                              )}
                            />
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Total AFN</strong>
                        </td>

                        <td>
                          <strong>
                            <AFNFigure
                              amount={trialBalances.reduce(
                                (accumulator, currentObject) => {
                                  if (currentObject.accountName.includes("AFN"))
                                    return accumulator + currentObject.debit;
                                  return accumulator;
                                },
                                0
                              )}
                            />
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <AFNFigure
                              amount={trialBalances.reduce(
                                (accumulator, currentObject) => {
                                  if (currentObject.accountName.includes("AFN"))
                                    return accumulator + currentObject.credit;
                                  return accumulator;
                                },
                                0
                              )}
                            />
                          </strong>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TrialBalance;
